import { StaticPageLayout, PageHero } from 'app/components/StaticPages';
import Testimonials from './Testimonials';

const TestimonialsScreen = () => (
  <StaticPageLayout
    title="Reviews & Testimonials | Kingdom Strollers"
    metaDescription="Take a look at our reviews & testimonials and see why Kingdom Strollers is the top-rated Orlando stroller rental service."
  >
    <PageHero
      align="center"
      eyebrow="What Families Say"
      title="Testimonials"
      subtitle="Real reviews from families who made memories a little easier with Kingdom Strollers."
      subtitleMaxWidth={540}
    />
    <Testimonials />
  </StaticPageLayout>
);

export default TestimonialsScreen;
